/**
*
* CapTopBar
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import classNames from 'classnames';
import CapDropdown from '../CapDropdown';
import CapPopover from '../CapPopover';
import CapMenu from '../CapMenu';
import CapIcon from '../CapIcon';
import CapDrawer from '../CapDrawer';
import CapList from '../CapList';
import CapLink from '../CapLink';
import CapHeading from '../CapHeading';
import CapTooltip from '../CapTooltip';
import CapLabel from '../CapLabel';
import { Select } from './Select';
import './_capTopBar.scss';
import { LogoBackground } from '../assets/icons';
import * as styledVars from "../styled/variables";
import CapDivider from '../CapDivider';
import { handleConnectPlusRedirection } from './utils';
import CapAskAira from '../CapAskAira';

const { Header } = Layout;

const clsPrefix = 'cap-navbar';
const CONNECT_PLUS = 'connectPlus';

const getLanguageName = (languageCode, locale = 'en') => {
  const updatedLanguageCode = languageCode?.split('_')[0];
  const formatter = new Intl.DisplayNames([locale], { type: 'language' });
  return formatter.of(updatedLanguageCode);
};

class CapTopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer: false,
      visible: false,
    };
  }

  renderTopMenu = () => {
    const { menuProps } = this.props;
    const { onMenuItemClick, items, ...restMenuProps } = menuProps;
    return (
      <CapMenu
        className={classNames(`${clsPrefix}-menu`)}
        mode="horizontal"
        style={{ lineHeight: styledVars.CAP_SPACE_64 }}
        {...restMenuProps}
      >
        {
          items && items.map((item) => (
            <CapMenu.Item
              className={classNames(`${clsPrefix}-menu-item`)}
              onClick={onMenuItemClick ? () => { onMenuItemClick(item); } : null}
              key={item.key}>
              {item.label}
            </CapMenu.Item>
          ))
        }
      </CapMenu>
    );
  }

  renderTopbarIcons = () => {
    const { topbarIcons, isLatestLeftNavigationEnabled } = this.props;
    return (
      React.Children.toArray(topbarIcons.map(({iconType, onClickHandler, className, toolTip, placement, ...rest}) => (
        <CapTooltip title={toolTip} placement={placement || "bottom"}>
          {
            iconType === 'custom'
              ? rest.content
              : (
                <CapIcon
                  onClick={onClickHandler ? () => { onClickHandler(); } : null}
                  className={classNames(`${clsPrefix}${isLatestLeftNavigationEnabled ? '-new' : ''}-topbarIcon`, className)}
                  type={iconType}
                  {...rest}
                />
              )
          }
        </CapTooltip>
      ))));
  }

  expandUserBackground = (flag) => {
    this.setState({ visible: flag });
  }

  userInfoContent = (dropdownMenuProps) => {
    const logOutProps = (dropdownMenuProps && dropdownMenuProps.length > 0) ? dropdownMenuProps[dropdownMenuProps.length - 1] : {};
    const {  user = {} } = this.props?.userData || {};
    const { firstName = '', loginName, iso_lang } = user;

    return (
      <div className='user-profile'>
        <div className='user-profile-name-wrapper'>
          <span className='.user-profile-avatar'> {firstName[0]} </span>
        </div>
        <span className='user-profile-name'>{firstName}</span>
        <p className='user-profile-loginName'>{loginName}</p>
        <div className='lang-wrapper'>
          <CapIcon className='lang-icon' type="global" size="s" />
          <span>{getLanguageName(iso_lang)}</span>
        </div>
        <CapDivider />
        <div className='logout-wrapper'>
          <CapIcon  type="exit" size="s" />
          <div 
            className='logout-text'
            onClick={logOutProps.onClickHandler ? () => { logOutProps.onClickHandler() } : null} >{logOutProps.label || ''}
          </div>
        </div>
      </div>
    );
  }

  renderDropdownMenu = () => {
    const { dropdownMenuProps, isLatestLeftNavigationEnabled, leftNavbarExpanded } = this.props;
    const { visible } = this.state;
    return (
      !isLatestLeftNavigationEnabled ? 
      <CapDropdown
        trigger={["click"]}
        onVisibleChange={this.expandUserBackground}
        overlay={(
          <CapMenu className={classNames(`${clsPrefix}-menu`)}>
            {dropdownMenuProps.map((dropdownMenuProp) => (
              <CapMenu.Item key={dropdownMenuProp.key}>
                <div onClick={dropdownMenuProp.onClickHandler ? () => { dropdownMenuProp.onClickHandler(); } : null} className={classNames(`${clsPrefix}-user-popover-item`)}>
                  <div>{dropdownMenuProp.label || ''}</div>
                </div>
              </CapMenu.Item>
            ))}
          </CapMenu>
        )}
        placement="bottomLeft">
        <div
          className={visible ?
            classNames(`${clsPrefix}${isLatestLeftNavigationEnabled ? '-new' : ''}-user oval
              ${leftNavbarExpanded ? 'expanded' : 'collapsed'}`) :
              classNames(`${clsPrefix}${isLatestLeftNavigationEnabled ? '-new' : ''}-user
              ${leftNavbarExpanded ? 'expanded' : 'collapsed'}`)}>
          <LogoBackground />
          <span className="text-label"><CapIcon type="person" size="s" className={(`${clsPrefix}-person`)}></CapIcon></span>
        </div>
      </CapDropdown> :
      <CapPopover 
        content={this.userInfoContent(dropdownMenuProps)}
        placement="bottomRight"
      >
        <div className={classNames(`${clsPrefix}${isLatestLeftNavigationEnabled ? '-new' : ''}-user 
          ${leftNavbarExpanded ? 'expanded' : 'collapsed'}`)}>
          <LogoBackground />
          <span className="text-label">
            <CapIcon type="person" size="s" className={`${clsPrefix}-person`} />
          </span>
        </div>
      </CapPopover>
    );
  }

  getDrawerTitle = (title) => (
    <div className={classNames(`${clsPrefix}-flexDisplay`)}>
      <CapIcon type="more-applications" className={classNames(`${clsPrefix}-more-app`)}></CapIcon>
      {title || ''}
    </div>
  )

  getDrawerContent = (productsList, handleProductChange, selectedProduct) => {
    let productsComps = [];
    if (productsList && handleProductChange && selectedProduct) {
      productsComps = productsList.map((product) => (
        <CapLink
          onClick={() => (product.key || '') !== CONNECT_PLUS ? handleProductChange(product)
            : handleConnectPlusRedirection({product: product, cluster:  window.location.host })
          }
          title={(
            product && selectedProduct.toLowerCase() === (product.value || '').toLowerCase() ? (
              <div style={{ display: 'flex', paddingLeft: styledVars.CAP_SPACE_32 }}>
                <CapIcon
                  type="tick"
                  size="s"
                  svgProps={{
                    fill: styledVars.CAP_BLUE01,
                  }}
                />
                <CapHeading type="h3" className={classNames(`${clsPrefix}-capitalize`)}>{product.value || ''}</CapHeading>
              </div>
            ) : (<div style={{ paddingLeft: styledVars.CAP_SPACE_60 }}><CapHeading type="h3" className={classNames(`${clsPrefix}-capitalize`)}>{product.value || ''}</CapHeading></div>))}

        />
      ));
    }
    return (<CapList dataSource={productsComps} renderItem={(item) => (<CapList.Item>{item}</CapList.Item>)} />);
  }

  renderDrawerList = () => {
    const { drawerListProps, isLatestLeftNavigationEnabled } = this.props;
    const { fixedProduct = false, productsList, selectedProduct, handleProductChange, title, ...rest } = drawerListProps;
    const { showDrawer } = this.state;
    return (
    <>
      <div
        className={classNames(`${clsPrefix}${isLatestLeftNavigationEnabled ? '-new' : ''}-dimensions`)}
        style={{ marginRight: '30px' }}
      >
        {fixedProduct
          ? <div><CapHeading type="h3" className={classNames(`${clsPrefix}-product-title`)}>{selectedProduct || ''}</CapHeading></div>
          : (
            <div onClick={this.openDrawer} className={classNames(`${clsPrefix}-flexDisplay`, `${clsPrefix}-cursor-pointer`)}>
              <CapIcon type="more-applications" className={classNames(`${clsPrefix}-more-app`)}></CapIcon>
              <CapHeading type="h3" className={classNames(`${clsPrefix}-capitalize`)}>{selectedProduct || ''}</CapHeading>
            </div>
          )}
        {showDrawer && drawerListProps && (
          <CapDrawer
            visible={showDrawer}
            onClose={this.closeDrawer}
            className={classNames(`${clsPrefix}-drawer`)}
            title={this.getDrawerTitle(title)}
            content={this.getDrawerContent(productsList, handleProductChange, selectedProduct)}
            {...rest} />
        )}
      </div>
      <CapDivider type="vertical" className="cap-top-bar-vertical" />
    </>
    );
  }

  renderOrgsSelect = () => {
    const { selectProps, isLatestLeftNavigationEnabled } = this.props;
    return (
      <div
        className={classNames(`${clsPrefix}${isLatestLeftNavigationEnabled ? '-new' : ''}-dimensions`)}
      >
        <Select
          {...selectProps}
        />
      </div>
    );
  }

  openDrawer = () => {
    this.setState({ showDrawer: true });
  }

  closeDrawer = () => {
    this.setState({ showDrawer: false });
  }

  renderBreadcrumbs = () => {
    const { breadcrumbs = '', leftNavbarExpanded = false } = this.props;
    return breadcrumbs ? (
      <CapLabel
        type="label2"
        className={`breadcrumbs-topbar-${
          leftNavbarExpanded ? 'expanded' : 'collapsed'
        }`}
      >
        {breadcrumbs}
      </CapLabel>
    ) : (
      ''
    );
  };
  renderDividerBeforeOrgSelect = (topbarIcons = [], showDocumentationBot)=> {
    return (
      (topbarIcons?.length > 0 || showDocumentationBot) && (
        <CapDivider type="vertical" className="cap-top-bar-vertical" style={{marginLeft:'1.714rem',marginRight:'1.714rem'}}/>
      )
    );
  }
  render() {
    const { drawerListProps, selectProps, menuProps, dropdownMenuProps, topbarIcons, breadcrumbs, showDocumentationBot, isLatestLeftNavigationEnabled = false, headerOverideCss = {}, request, getAPICallObject } = this.props;
    return (
      <Header
        style={{...headerOverideCss}}
        className={classNames(`${clsPrefix}${isLatestLeftNavigationEnabled ? '-new' : ''}-header`)}
      >
        <div className={classNames(`${clsPrefix}-flexDisplay`)}>
          {isLatestLeftNavigationEnabled && breadcrumbs && this.renderBreadcrumbs()}
          {!isLatestLeftNavigationEnabled && drawerListProps && this.renderDrawerList()}
          {!isLatestLeftNavigationEnabled && selectProps && this.renderOrgsSelect()}
        </div>
        {menuProps && this.renderTopMenu()}
        {topbarIcons && this.renderTopbarIcons()}
        {showDocumentationBot && <CapAskAira.DocumentationChatBot request={request} getAPICallObject={getAPICallObject}/>}
        {isLatestLeftNavigationEnabled && selectProps && (<>{this.renderDividerBeforeOrgSelect(topbarIcons,showDocumentationBot)}{this.renderOrgsSelect()}</>)}
        {dropdownMenuProps && this.renderDropdownMenu()}        
        {this.props.children}
      </Header>
    );
  }
}

CapTopBar.propTypes = {
  drawerListProps: PropTypes.shape({
    fixedProduct: PropTypes.bool,
    productsList: PropTypes.array,
    selectedProduct: PropTypes.string,
    handleProductChange: PropTypes.func,
  }),
  selectProps: PropTypes.object,
  menuProps: PropTypes.object,
  topbarIcons: PropTypes.array,
  dropdownMenuProps: PropTypes.array,
  userName: PropTypes.string,
  breadcrumbs: PropTypes.array,
  headerOverideCss: PropTypes.object,
};

export default CapTopBar;
